import ACTIONS from "../../constants/actions";

const localStorageKey = 'main';
const dataFromLs = localStorage.getItem(localStorageKey);

const defaultData = {
	isFirstVisit : true,
	isDopShow    : false,
	factors      : {}
};

const initialState = dataFromLs ? JSON.parse(dataFromLs) : defaultData;

export default function main(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.MAIN.SET_VISIT: {
			const newState = {isFirstVisit : false};
			const newData = Object.assign({}, {...state, ...newState});
			localStorage.setItem(localStorageKey, JSON.stringify(newData));
			return newData;
		}
		case ACTIONS.MAIN.GET_FACTORS: {
			const newState = {factors : action.data};
			const newData = Object.assign({}, {...state, ...newState});
			localStorage.setItem(localStorageKey, JSON.stringify(newData));
			return newData;
		}
		case ACTIONS.MAIN.TOOGLE_DOP_SHOW : {
			return {...state, isDopShow : !state.isDopShow};
		}
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/main.js